import { getChannel } from '../../getChannel';

export const NHS_TERMS_URL =
  'https://s3-eu-west-1.amazonaws.com/cdn.unmind.io/CMS/unmindApp/assets/termsOfUse/Unmind_TermsOfUse_NHS.pdf';

export default (subdomain?: string) =>
  subdomain === 'nhs' ? NHS_TERMS_URL : getChannel().termsUrl;
